"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapGetTournamentsRequestToGetTournamentsCounters = exports.mapGetEventsListFiltersToGetEventCounters = exports.updateEventCounterState = exports.setErrorEventCounterState = exports.setSuccessEventCounterState = exports.setLoadingEventCounterState = exports.formatEventsSportCountersResponse = exports.formatFetchEventCountersReqData = void 0;
const utils_1 = require("../../utils");
const formatFetchEventCountersReqData = (data) => {
    const normalizeValue = (value) => {
        if (Array.isArray(value)) {
            return [...value].sort();
        }
        return value;
    };
    const sortedEntries = Object.entries(data)
        .map(([key, value]) => [key, normalizeValue(value)])
        .sort(([keyA], [keyB]) => keyA.localeCompare(keyB));
    return Object.fromEntries(sortedEntries);
};
exports.formatFetchEventCountersReqData = formatFetchEventCountersReqData;
const formatEventsSportCountersResponse = (response) => {
    return {
        ...response,
        bySport: {
            entries: (0, utils_1.toIdsMap)(response.bySport),
            ids: (0, utils_1.toIdsArray)(response.bySport),
        },
        byTournament: {
            entries: (0, utils_1.toIdsMap)(response.byTournament),
            ids: (0, utils_1.toIdsArray)(response.byTournament),
        },
    };
};
exports.formatEventsSportCountersResponse = formatEventsSportCountersResponse;
const initializeEventCounterState = () => ({
    fetchItems: { ...utils_1.requestInitialState },
    data: null,
});
const setLoadingEventCounterState = (state, key) => {
    if (!state[key]) {
        state[key] = initializeEventCounterState();
    }
    state[key].fetchItems.loading = true;
    state[key].fetchItems.error = null;
};
exports.setLoadingEventCounterState = setLoadingEventCounterState;
const setSuccessEventCounterState = (state, key) => {
    if (state[key]) {
        state[key].fetchItems.loading = false;
        state[key].fetchItems.error = null;
        state[key].fetchItems.loaded = true;
    }
};
exports.setSuccessEventCounterState = setSuccessEventCounterState;
const setErrorEventCounterState = (state, key, error) => {
    if (state[key]) {
        state[key].fetchItems.loading = false;
        state[key].fetchItems.error = error;
        state[key].fetchItems.loaded = true;
    }
};
exports.setErrorEventCounterState = setErrorEventCounterState;
const updateEventCounterState = (state, key, data) => {
    state[key].data = data;
};
exports.updateEventCounterState = updateEventCounterState;
const mapGetEventsListFiltersToGetEventCounters = (eventsRequest) => {
    const eventCountersRequest = {
        live: eventsRequest.live,
        statuses: eventsRequest.statuses,
        scheduledTo: eventsRequest.scheduledTo,
        scheduledFrom: eventsRequest.scheduledFrom,
        includeSubsports: eventsRequest.includeSubsports,
        hasLineOutcomes: eventsRequest.hasLineOutcomes,
    };
    if (eventsRequest.hasActiveLineOutcomes !== undefined) {
        eventCountersRequest.hasLineOutcomes = eventsRequest.hasActiveLineOutcomes;
    }
    return eventCountersRequest;
};
exports.mapGetEventsListFiltersToGetEventCounters = mapGetEventsListFiltersToGetEventCounters;
const mapGetTournamentsRequestToGetTournamentsCounters = (tournamentsRequest) => {
    const countersRequest = {
        sportIds: tournamentsRequest.sportIds,
        statuses: tournamentsRequest.eventStatuses,
        scheduledTo: tournamentsRequest.scheduledTo,
        scheduledFrom: tournamentsRequest.scheduledFrom,
        searchQuery: tournamentsRequest.searchQuery,
        searchQueryFields: tournamentsRequest.searchQueryFields,
        locale: tournamentsRequest.locale,
        includeSubsports: tournamentsRequest.includeSubsports,
        hasLineOutcomes: tournamentsRequest.eventHasLineOutcomes,
    };
    return countersRequest;
};
exports.mapGetTournamentsRequestToGetTournamentsCounters = mapGetTournamentsRequestToGetTournamentsCounters;
//# sourceMappingURL=utils.js.map